/* eslint-disable @typescript-eslint/no-explicit-any */
import { RuleParamSchema, StringOrNumber, ValidationMessageTemplate } from 'vee-validate/dist/types/types.d';
import { isNullOrUndefined } from '@/utils/type-checker';
import { fullWidthLength } from '@/utils/string';

const name = 'full_width_max';

const validate = (
  value: StringOrNumber | StringOrNumber[],
  { length }: Record<string, any>,
): boolean => {
  if (isNullOrUndefined(value)) {
    return length >= 0;
  }

  if (Array.isArray(value)) {
    return value.every((val) => validate(val, { length }));
  }
  return fullWidthLength(String(value)) <= length;
};

const params: RuleParamSchema[] = [
  {
    name: 'length',
    default: null,
  },
];

const message: ValidationMessageTemplate = (
  field,
  {
    length,
  },
) => `${field} 不能大於 ${length} 個半形字元或 ${length / 2} 個全形字元`;

export { validate, params };

export default {
  name,
  validate,
  params,
  message,
};
